import {AppServiceWorker} from "./AppServiceWorker";

export const App = AppServiceWorker;
